import { BgColorsOutlined } from '@ant-design/icons'
import { Button, Popover, PopoverProps } from 'antd'
import React, { FunctionComponent, useCallback, useState } from 'react'

import {
  ColorPalleteDeafultOption,
  ColorPalleteKey,
} from '../../utils/collorPallete'
import {
  IconPalleteDeafultOption,
  IconPalleteKey,
} from '../../utils/iconPallete'
import { LabelSettingButtonBadge } from '../LabelSettingButtonBadge/LabelSettingButtonBadge'
import { LabelSettingButtonPopover } from '../LabelSettingButtonPopover/LabelSettingButtonPopover'

export interface LabelSettingButtonProps {
  pickedColor?: ColorPalleteKey
  pickedIcon?: IconPalleteKey
  labelName?: string
  labelDescription?: string
  popoverProps: PopoverProps
  handleDisable?: () => void
  onStyleChange: (style: {
    colorKey?: ColorPalleteKey
    iconKey?: IconPalleteKey
  }) => void
}

export const LabelSettingButton: FunctionComponent<LabelSettingButtonProps> =
  props => {
    const [isOpen, setIsOpen] = useState(false)

    const handleClose = useCallback(() => {
      setIsOpen(false)
      props.handleDisable?.()
    }, [props])

    const toggleOpen = useCallback(() => {
      setIsOpen(prev => !prev)
      props.handleDisable?.()
    }, [props])

    const initialColor = props.pickedColor || ColorPalleteDeafultOption
    const initialIcon = props.pickedIcon || IconPalleteDeafultOption

    return (
      <Popover
        placement="top"
        open={isOpen}
        content={
          <LabelSettingButtonPopover
            handleClose={handleClose}
            onStyleChange={props.onStyleChange}
            initialColor={initialColor}
            initialIcon={initialIcon}
            labelName={props.labelName}
            labelDescription={props.labelDescription}
          />
        }
        {...props.popoverProps}
      >
        <LabelSettingButtonBadge colorKey={initialColor} iconKey={initialIcon}>
          <Button
            onClick={toggleOpen}
            type="primary"
            ghost
            title="Nastavit vzhled štítku"
            icon={<BgColorsOutlined />}
          />
        </LabelSettingButtonBadge>
      </Popover>
    )
  }
